import { InteractiveContainer } from "@jugl-web/ui-kit";
import { cx, useTranslations } from "@jugl-web/utils";
import React from "react";
import { getFileSizeLabel } from "@jugl-web/utils/utils/files";
import { ReactComponent as PricingIcon } from "./assets/pricing.svg";
import { AgentTrainingSource } from "../../../../types";

export const AgentKnowledgeMenuItem: React.FC<{
  icon: React.ReactNode;
  type: AgentTrainingSource;
  title: string;
  count: number;
  size: number;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => void;
}> = ({ type, title, icon, count, size, isSelected, isDisabled, onClick }) => {
  const { t } = useTranslations();

  const countLabel = React.useMemo(() => {
    if (type === AgentTrainingSource.website) {
      return t(
        {
          id: "cx-ai-agents-page.links-count",
          defaultMessage: "{count} {count, plural, one {link} other {links}}",
        },
        { count }
      );
    }
    if (type === AgentTrainingSource.files) {
      return t(
        {
          id: "cx-ai-agents-page.files-count",
          defaultMessage: "{count} {count, plural, one {file} other {files}}",
        },
        { count }
      );
    }
    return t(
      {
        id: "cx-ai-agents-page.items-count",
        defaultMessage: "{count} {count, plural, one {item} other {items}}",
      },
      { count }
    );
  }, [type, count, t]);

  return (
    <InteractiveContainer
      className={cx(
        "flex items-center justify-between rounded-2xl border border-solid border-grey-400 bg-white p-4 transition-colors",
        isSelected && "border-dark-700"
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        {icon}
        <span className="font-secondary leading-4 text-dark">{title}</span>
      </div>
      <div className="flex items-center gap-3">
        <div className={cx(isDisabled && "opacity-40")}>
          <span className="font-secondary text-sm leading-[21px] text-dark-700">
            {countLabel} •
          </span>{" "}
          <span className="font-secondary text-sm leading-[21px] text-dark">
            {getFileSizeLabel(size)}
          </span>
        </div>
        {isDisabled && <PricingIcon />}
      </div>
    </InteractiveContainer>
  );
};
